import vibrateDeviceImg from '../../assets/setup/vibrate_device.png';
import { WarningAlert } from 'src/components/WarningAlert';

// component props interface 
interface Props {
    isMobileView: boolean;
}


export const VibrateDevice: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p>Vibrates your Android device.</p>
            <WarningAlert message="<a href='https://christinak.itch.io/deck-hopper-advanced'>Deck Hopper Advanced</a></strong> extension must be installed and running."/>
            <div>
                Use <b>Deck Hopper Vibrate</b> command to vibrate your Android device:
                <ul className="flex flex-col gap-y-2 list-disc list-inside ms-8 ">
                    <li>Client Name - leave empty to vibrate all devices, or enter the name of the Deck Hopper client to vibrate</li>
                    <li>Type - select Vibrate, Impact, or Notification</li>
                    <li>Vibrate Duration - enter the duration in milliseconds (only applicable if Type is Vibrate)</li>
                    <li>Impact Type - select the impact type (only applicable if Type is Impact)</li>
                    <li>Notification Type - select the notification type (only applicable if Type is Notification)</li>
                </ul>
            </div>
            <div>
                <p>Inside Deck Hopper Advanced premade deck, you can find an example "Vibrate Device" button to vibrate your device.</p>
            </div>
            <img src={vibrateDeviceImg} alt="Vibrate Device" width="800px" />
        </div>
    )
}